import { BaseResponse } from './base.response';
import { Item } from '../models';

export class ItemsResponse extends BaseResponse {

  public items: Item[];

}
